import { bootstrapApplication } from '@angular/platform-browser';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { register as registerSwiperElement } from 'swiper/element/bundle';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import { registerLocaleData } from '@angular/common';
import localeVi from '@angular/common/locales/vi';
import { LOCALE_ID } from '@angular/core';

registerLocaleData(localeVi, 'vi');
registerLocaleData(localeVi, 'vi-VN');

Chart.register(ChartDataLabels);
registerSwiperElement();

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [...(appConfig.providers || []), { provide: LOCALE_ID, useValue: 'vi' }]
}).catch(err => console.error(err));
